/* eslint-disable max-lines-per-function */
import { Table } from '@equinor/eds-core-react';
import { GetObjectResultsDto } from '../../../../../api/generated';
import * as Styled from './ChannelResultTable.styled';
import { useResultMetadata } from '../../hooks/useResultMetadata';

const NumberOfDecimals = 2;

export const ChannelResultTable = ({ data }: { data: GetObjectResultsDto }) => {
  const { computeMethod, archelName: archel } = useResultMetadata(
    data.computeCaseId,
  );
  const roundResultString = (value?: number) => {
    if (value) {
      return value.toFixed(NumberOfDecimals);
    }
  };

  return (
    <Styled.Table>
      <Table.Head>
        <Table.Row>
          <Styled.InfoCell></Styled.InfoCell>
          <Styled.DataCell>Mean</Styled.DataCell>
          <Styled.DataCell>Standard deviation (SD)</Styled.DataCell>
          <Styled.DataCell>Count</Styled.DataCell>
        </Table.Row>
      </Table.Head>
      <Table.Body key={data.computeCaseId}>
        <Table.Row>
          <Styled.ColumnCell>
            {computeMethod !== 'ObjectEstimation'
              ? `${computeMethod} width`
              : `${
                  archel ? archel.charAt(0).toUpperCase() + archel.slice(1) : ''
                } Width`}
          </Styled.ColumnCell>
          <Styled.DataCell>
            {roundResultString(data.width?.mean)}
          </Styled.DataCell>
          <Styled.DataCell>{roundResultString(data.width?.sd)}</Styled.DataCell>
          <Styled.DataCell>{data.width?.count}</Styled.DataCell>
        </Table.Row>
        <Table.Row>
          <Styled.ColumnCell>
            {computeMethod !== 'ObjectEstimation'
              ? `${computeMethod} height`
              : `${
                  archel ? archel.charAt(0).toUpperCase() + archel.slice(1) : ''
                } Height`}
          </Styled.ColumnCell>
          <Styled.DataCell>
            {roundResultString(data.height?.mean)}
          </Styled.DataCell>
          <Styled.DataCell>
            {roundResultString(data.height?.sd)}
          </Styled.DataCell>
          <Styled.DataCell>{data.height?.count}</Styled.DataCell>
        </Table.Row>
        <Table.Row>
          <Styled.ColumnCell>
            {computeMethod !== 'ObjectEstimation'
              ? `${computeMethod} length`
              : `${
                  archel ? archel.charAt(0).toUpperCase() + archel.slice(1) : ''
                } Length`}
          </Styled.ColumnCell>
          <Styled.DataCell>
            {roundResultString(data.length?.mean)}
          </Styled.DataCell>
          <Styled.DataCell>
            {roundResultString(data.length?.sd)}
          </Styled.DataCell>
          <Styled.DataCell>{data.length?.count}</Styled.DataCell>
        </Table.Row>
      </Table.Body>
    </Styled.Table>
  );
};
